import {
  NOTIFICATION_TYPE_ERROR,
  // NOTIFICATION_TYPE_INFO,
  NOTIFICATION_TYPE_SUCCESS,
  createNotification
} from 'react-redux-notify'
// Notify container config factory
const commonStyles = {
  'actionBtn': 'actionBtn',
  'close': 'close delete',
  'close-all': 'close-all',
  'content': 'notification-content',
  'has-close': 'has-close',
  'has-close-all': 'has-close-all',
  'has-close-all--noDismiss': 'has-close-all--noDismiss',
  'icon': 'icon',
  'item': 'item',
  'item--btnBar': 'item--btnBar',
  'item__message': 'item--message is-size-7',
  'no-close': 'no-close',
  'notification--error': 'notification--error notification is-danger is-radiusless',
  'notification--info': 'notification--info notification is-info is-radiusless',
  'notification--success': 'notification--success notification is-success is-radiusless',
  'notification--warning': 'notification--warning notification is-warning is-radiusless'
}

export function getNotifyOpts() {
  const node = document.querySelector('.notify-container')

  return {
    position: 'TopCenter',
    node,
    customStyles: {
      'containerTopCenter': 'containerTopCenter',
      'containerTopLeft': 'containerTopLeft',
      'containerTopRight': 'containerTopRight',
      'containerBottomLeft': 'containerBottomLeft',
      'containerBottomRight': 'containerBottomRight',
      'wrapper': 'wrapper container',
      'enter': 'enter',
      'leave': 'leave',
      'notification-show': 'notification-show',
      'notification-hide': 'notification-hide',
      'notification-shrink': 'notification-shrink'
    }
  }
}

// Notifications config factories
export function errorNotificationOpts({ message = '', duration = 4000, canDimiss = true, icon = null }) {
  return {
    message,
    type: NOTIFICATION_TYPE_ERROR,
    duration,
    canDimiss,
    icon,
    customStyles: commonStyles
  }
}

export function successNotificationOpts({ message = '', duration = 4000, canDimiss = true, icon = null }) {
  return {
    message,
    type: NOTIFICATION_TYPE_SUCCESS,
    duration,
    canDimiss,
    icon,
    customStyles: commonStyles
  }
}

export function notify({ message, type, options = {} }) {
  return function(dispatch) {
    const typesMap = {
      'error': errorNotificationOpts,
      'success': successNotificationOpts
    }

    if (typesMap[type]) {
      const notification = typesMap[type]({
        message,
        ...options
      })
      dispatch(createNotification(notification))
    }
  }
}



// WEBPACK FOOTER //
// ./lib/notification.js